import React from "react";
import { ModalContainer } from "./style";
const Modal = ({ status, close, children,size="small" }) => {
  if (typeof document !== "undefined") {
    window.document.body.style.overflow = status ? "hidden" : "auto";
    window.document.body.style.touchAction = status ? "none" : "auto";
  }
  if (!status) {
    return null;
  } else {
    return (
      <ModalContainer size={size}>
        <div className="overlay" onClick={close}/>
        <div className="body">{children}</div>
      </ModalContainer>
    );
  }
};
export default Modal;
